module.exports = __webpack_public_path__ + "static/img/info-best-logo.eaeb030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/info-best-logo.png
// module id = zukF
// module chunks = 134